import { render, staticRenderFns } from "./CourseTestReport.vue?vue&type=template&id=47f4fa06&scoped=true&"
import script from "./CourseTestReport.vue?vue&type=script&lang=js&"
export * from "./CourseTestReport.vue?vue&type=script&lang=js&"
import style0 from "./CourseTestReport.vue?vue&type=style&index=0&id=47f4fa06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4fa06",
  null
  
)

export default component.exports